import { QueryClient } from "@tanstack/react-query";
import { RealtimeUpdateEvent } from "../types";
import { queryKeys } from "./queryKeys";

export const applyRealtimeUpdateToQueryCache = (
  queryClient: QueryClient,
  event: RealtimeUpdateEvent
) => {
  if (!event?.EntityType || !event?.ChangeType) {
    return;
  }

  if (event.EntityType === "Group" && event.ChangeType === "Delete") {
    queryClient.removeQueries({ queryKey: queryKeys.myParty(event.Id) });
    queryClient.removeQueries({ queryKey: queryKeys.promoterGroup(event.Id) });
  }

  if (event.EntityType === "Group" && event.Id) {
    void queryClient.invalidateQueries({ queryKey: queryKeys.myParty(event.Id) });
    void queryClient.invalidateQueries({ queryKey: queryKeys.promoterGroup(event.Id) });
  }

  void queryClient.invalidateQueries({ queryKey: queryKeys.myParties() });
  void queryClient.invalidateQueries({ queryKey: queryKeys.promoterGroupsRoot() });
  void queryClient.invalidateQueries({ queryKey: queryKeys.acceptedGroups() });
  void queryClient.invalidateQueries({ queryKey: queryKeys.alsoGoingOutGroupsRoot() });
};
